/* eslint-disable linebreak-style */
import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ClientService } from '../../../client.service';
import {
  IdentifierTypeDocument,
  TypeTypeDocument,
  GroupLoyaltyTypeDocument,
  IDENTIFIER_ID
} from '../../../interfaces/tercero.interface';
import {
  CLIENT_TTL_ES,
  IClientBase
} from '../../../interfaces/client.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
@Component({
  selector: 'pg-client-create',
  templateUrl: './client-create.component.html',
  providers: [MessageService]
})
export class ClientCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  loading: boolean = false;
  typesDocument = IdentifierTypeDocument;
  typeDocumentDefault = IdentifierTypeDocument[0].id;
  typesTypeDocument = TypeTypeDocument;
  typeDocumentGroupLoyalty = GroupLoyaltyTypeDocument;

  constructor(
    private fb: FormBuilder,
    private serviceBase: ClientService,
    private messageService: MessageService
  ) {
    super(CLIENT_TTL_ES, serviceBase);
  }

  ngOnInit(): void {
    this.fg = this.fb.group({
      identifierId: ['', [Validators.required]],
      idNumber: [
        '',
        [Validators.required, Validators.minLength(8), Validators.maxLength(11)]
      ],
      email: ['', [Validators.minLength(5), Validators.maxLength(255)]],
      phone: ['', [Validators.minLength(9), Validators.maxLength(9)]],
      name: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      typeId: ['', []],
      groupLoyaltyId: ['', []],
      address: ['', [Validators.maxLength(255)]]
    });
  }

  onSubmit() {
    const client = this.parseData();
    this.createItem$(client);
  }

  async onComplete() {
    const type = IDENTIFIER_ID[this.fg.get('identifierId').value].toLowerCase();
    const identity = this.fg.get('idNumber').value;

    if (type === 'pasaporte') {
      this.showErrorMessage('No se puede obtener el nombre de un pasaporte');
      return;
    }

    if (type === 'dni' && identity.length !== 8) {
      this.showErrorMessage('El DNI debe tener 8 caracteres');
      return;
    }

    if (type === 'ruc' && identity.length !== 11) {
      this.showErrorMessage('El RUC debe tener 11 caracteres');
      return;
    }

    this.loading = true;

    try {
      const response = await this.serviceBase.getFullName(type, identity);
      if (response.status !== 200) {
        this.fg.get('name').setValue('');
        this.showErrorMessage(response.message);
        return;
      }
      const data = response.data as any;
      this.fg.get('name').setValue(data.name);
    } catch (error) {
      this.fg.get('name').setValue('');
      this.showErrorMessage('Hubo un error al obtener el nombre');
    } finally {
      this.loading = false;
    }
  }

  private showErrorMessage(message: string) {
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message
    });
  }

  private parseData() {
    const client = this.fg.value as IClientBase;
    const { typeId, groupLoyaltyId } = this.fg.value;
    if (client.address === '') delete client.address;
    if (client.email === '') delete client.email;
    if (client.phone === '') delete client.phone;
    if (typeId === '') delete client.typeId;
    if (groupLoyaltyId === '') delete client.groupLoyaltyId;
    return client;
  }
}
